import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[carbonControlErrorsContainer]',
})
export class ControlErrorsContainerDirective {
  constructor(public vcr: ViewContainerRef) {}
}
